import React from 'react';
import { Form, Select } from 'antd';
const { Option } = Select;

const ResponsiblePerson = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Ответственный:">
      {getFieldDecorator('personResponsible')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите ответственного"
          allowClear={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          <Option key={1}>API не подключено</Option>
        </Select>
      )}
    </Form.Item>
  );
};

export default ResponsiblePerson;
